import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Heading from "../../elements/heading";
import "./style.scss";
import classNames from "classnames";
import { gtag } from "../../utils";
import { withRouter } from "react-router-dom";
import { scrollToSmoothTryMultipleTimes } from "../../hooks/scrollToSmooth.js";

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items_: this.props.fields ? this.props.fields.items : [],
      urlHashId: "",
      urlHashIndex: -1
    };
  }

  toggle = (index, event) => {
    gtag('event', 'Component_info', {
      'component_name': 'Accordion',
      'page_title': this?.props?.page?.name
    });
    event.preventDefault();
    let newState = this.props.fields ? this.props.fields.items : [];
    if (newState[index].fields.collapsed) {
      newState[index].fields.collapsed.value = !newState[index].fields.collapsed.value;
    }

    const noOpenItemAccordinToUrl = newState[index].fields.collapsed && newState[index].fields.collapsed.value;

    this.setState({ items_: newState, urlHashIndex: noOpenItemAccordinToUrl ? -1 : index });

    this.props.history.push(noOpenItemAccordinToUrl ? window.location.pathname : `${window.location.pathname}#${this.props.rendering.uid};${index}`);
  };

  accordionContent(fields) {
    const { paddingAboveTop, paddingAboveBottom, alignment, backgroundColor, headingBody, headingType, bodyText, gridType, items } = fields;
    let { urlHashId, urlHashIndex } = this.state;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default",
      alignContent = alignment ? alignment.fields.phrase.value : "",
      gridTypeDate = gridType && gridType.fields.phrase.value === "story" ? "grid-story" : "grid";
    const accordionClasses = classNames("accordion grid", "padding-top-" + top, "padding-bottom-" + bottom, alignContent, gridTypeDate),
      headClasses = classNames("head"),
      bodyClasses = classNames("body"),
      itemsClasses = classNames("items"),
      titleClasses = classNames("title"),
      descriptionClasses = classNames("description");
    let backgroundStyle = {
      background: backgroundColor ? backgroundColor.fields.phrase.value : "transparent"
    };
    return (
      <section className={accordionClasses} style={backgroundStyle} datasourceid={this.props.rendering.dataSource}>
        {headingBody && headingBody.value && (
          <div className={headClasses}>
            <Heading
              {...{
                type: headingType,
                html: headingBody
              }}
              typographyClass="type-h2"
              className={"component-title"}
            />
          </div>
        )}

        {bodyText && bodyText.value && <RichText className={bodyClasses} field={bodyText} tag="div" />}

        <div className={itemsClasses}>
          {items &&
            items.length > 0 &&
            items.map((item, index) => {
              return (
                <div className={`item`} key={index} onClick={evt => this.toggle(index, evt)} id={`${this.props.rendering.uid};${index}`}>
                  <div className={`${titleClasses} ${item.fields.headingType && item.fields.headingType.fields.phrase.value}`}>
                    <Heading
                      {...{
                        type: item.fields.headingType && item.fields.headingType,
                        html: item.fields.headingBody && item.fields.headingBody
                      }}
                      className={`${item.fields.collapsed && !item.fields.collapsed.value ? "close" : "plus"}`}
                    />
                  </div>
                  {item.fields.body && (
                    <RichText
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      field={item.fields.body}
                      tag="div"
                      className={item.fields.collapsed && item.fields.collapsed.value ? descriptionClasses : `${descriptionClasses} expanded`}
                    />
                  )}
                </div>
              );
            })}
        </div>
      </section>
    );
  }

  componentDidMount() {
    const { rendering } = this.props;
    const urlHashId = window.location.hash && window.location.hash.split(";").length > 1 ? window.location.hash.split(";")[0].replace("#", "") : "",
      urlHashIndex = urlHashId && urlHashId === rendering.uid ? +window.location.hash.split(";")[1] : -1;

    if (urlHashIndex >= 0 && rendering.uid === this.props.rendering.uid) {
      let items = this.props.fields ? this.props.fields.items : [];
      items[urlHashIndex].fields.collapsed.value = false;

      this.setState({
        items_: items,
        urlHashId: urlHashId,
        urlHashIndex: urlHashIndex
      });

      /** delay the scroll a litle to get the page a chance to load
       * so scroll positions is right.
       */
      setTimeout(function() {
        scrollToSmoothTryMultipleTimes(`${urlHashId};${urlHashIndex}`);
      }, 300);
    }
  }

  render() {
    if (!this.props.fields) return null;
    const { fields } = this.props;
    const { gridType } = fields;
    if (gridType && gridType.fields.phrase.value === "story") {
      return <div className={"grid"}>{this.accordionContent(fields)}</div>;
    } else {
      return this.accordionContent(fields);
    }
  }
}
export default withRouter(Accordion);
